<script>
  import { createEventDispatcher } from "svelte";
  import NauiInput from "../../../lib/naui/atoms/NauiInput.svelte";
  import "../../../../static/front/css/lib/astillero/_formAud.css";
  import { onMount } from "svelte";
  import { writable } from "svelte/store";
  import {maxLenghtInput} from "../../../lib/utils/index";

  export let data;
  export let local_hora; 
  export let hasError;

  const dispatch = createEventDispatcher();
  let showWarning = writable(false);

  let proveedorData = {
    proveedor: data.vendor,
    fecha: data.hora_fin_aud ? data.fecha_aud : new Date().toLocaleDateString('en-CA', { timeZone: 'America/Bogota' }),
    hora_aud: data.hora_fin_aud ? data.hora_aud : $local_hora,
    hora_fin_aud: data.hora_fin_aud ? data.hora_fin_aud :"",
    codigoRef: data.codigo_referencia,
    nombreRef: data.nombre_referencia,
    marca: data.marca,
    importacion: data.importacion,
    po: data.po,
    entrega: data.entrega,
    ppk_unidades: data.ppk_unidades,
    individual_unidades: data.individual_unidades,
    tipo_prenda: data.tipo_prenda
  };

  function actualizarDatos() {
    dispatch("update", { label: "Proveedor", data: { ...proveedorData } });
  }

  onMount(() => {
    actualizarDatos();
  });

  $: {
    if (!proveedorData.tipo_prenda || proveedorData.tipo_prenda === "") {
      showWarning.set(true);
    } else {
      showWarning.set(false);
    }
  }
  $: {
    if(
      $showWarning
    )
    {
      hasError.update(errors => [...errors, 'Datos Generales']);
    }else{
      hasError.update(errors => errors.filter(error => error !== 'Datos Generales'));
    }
    
  }



  
</script>

<div class="containerMain">
  <div class="Proveedor-container">
    <div class="Proveedor-first">
      <NauiInput class="custom-style" label="PROVEEDOR:" isDisabled type="text" bind:value={proveedorData.proveedor} on:input={actualizarDatos} />
      <NauiInput class="custom-style" label="FECHA:" isDisabled type="text" bind:value={proveedorData.fecha} on:input={actualizarDatos} />
      <NauiInput class="custom-style" label="HORA INICIO:" isDisabled type="text" bind:value={$local_hora} on:input={actualizarDatos} />
      <NauiInput class="custom-style" label="HORA FINAL:" isDisabled type="text" bind:value={proveedorData.hora_fin_aud} on:input={actualizarDatos} />
    </div>

    <div class="Proveedor-mid">
      <div class="mid-code">
        <NauiInput class="custom-mid-style" label="CODIGO REF:" isDisabled type="text" bind:value={proveedorData.codigoRef} on:input={actualizarDatos} />
        <NauiInput class="custom-mid-style" label="NOMBRE REF:" isDisabled type="text" bind:value={proveedorData.nombreRef} on:input={actualizarDatos} />
      </div>
      <NauiInput class="custom-style" label="MARCA:" isDisabled type="text" bind:value={proveedorData.marca} on:input={actualizarDatos} />
      <NauiInput
      class="custom-style"
      label="IMPORTACIÓN"
      type="text"
      bind:value={proveedorData.importacion}
      on:input={(e)=>{
        proveedorData.importacion = maxLenghtInput(e, 255);
        actualizarDatos();
      }}
      />
      <NauiInput class="custom-style" label="PO:" isDisabled type="text" bind:value={proveedorData.po} on:input={actualizarDatos} />
    </div>

    <div class="Proveedor-end" style="align-items: flex-start !important">
      <NauiInput class="custom-style"
        label="ENTREGA:"
        type="text"
        bind:value={proveedorData.entrega}
        on:input={(e)=>{
          proveedorData.entrega = maxLenghtInput(e, 255);
          actualizarDatos();
        }}
      />
      <NauiInput class="custom-style"
        label="PPK:"
        type="number"
        bind:value={proveedorData.ppk_unidades}
        on:input={(e)=>{
          proveedorData.ppk_unidades = maxLenghtInput(e, 9);
          actualizarDatos();
        }}
      />
      <NauiInput
        class="custom-style"
        label="INDIVIDUAL:"
        type="number"
        bind:value={proveedorData.individual_unidades}
        on:input={(e)=>{
          proveedorData.individual_unidades = maxLenghtInput(e, 9);
          actualizarDatos();
        }}
      />
      
      <NauiInput
        class='custom-style {!proveedorData.tipo_prenda || proveedorData.tipo_prenda === "" ? "red-border" : ""}'
        label="TIPO DE PRENDA:"
        type="text"
        bind:value={proveedorData.tipo_prenda}
        on:input={(e)=>{
          proveedorData.tipo_prenda=maxLenghtInput(e, 255);
          actualizarDatos()
        }}
      />
      {#if $showWarning && (!proveedorData.tipo_prenda || proveedorData.tipo_prenda === "")}
        <p class="error-message">Este campo es obligatorio</p>
      {/if}
      
    </div>
  </div>
</div>

<style>
  .Proveedor-container {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    height: 100%;
    justify-content: space-around;
  }

  .Proveedor-first,
  .Proveedor-mid,
  .Proveedor-end {
    width: 32%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
  }
  .mid-code {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }

  :global(.custom-style.naui-field) {
    width: 100%;
  }

  :global(.custom-mid-style.naui-field) {
    width: 48%;
  }

  @media (max-width: 930px) {
    .Proveedor-container {
      display: flex;
      flex-direction: column;
      flex-grow: none;
      justify-content: start;
      align-items: center;
    }
    .Proveedor-first,
    .Proveedor-mid,
    .Proveedor-end {
      width: 100%;
      height: auto;
    }
  }
  :global(.red-border.naui-field input label) {
    border: 1px solid #ff5a5f;
  }
  :global(.red-border.naui-field.active label) {
    color: red;
  }
  
</style>
